import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ShowError = (error) => {
  let alertCount = 0;

  if (alertCount === 0) {
    alertCount++;
    let message = "";
    if (error.response.status === 403) message = "Unauthenticated error";
    if (error.response.status === 404)
      message = "The firewall is blocking incoming requests to the API";
    if (error.response.status === 500) message = "Internal server error";
    const config = {
      position: "top-right",
      className: "custom-toast",
    };
    return toast.error(message, config);
  }
};

export default ShowError;
